export function products(state) {
  return state.products;
}
export function total(state) {
  return state.total;
}
export function subtotal(state) {
  return state.subtotal;
}
export function quantity(state) {
  return state.quantity;
}
export function delivery(state) {
  return state.delivery;
}